import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid ${COLORS.GREY};
  padding: 1.5rem 2rem;
  background-color: ${COLORS.GRAY_LIGHT};
`;
